import { createContext, useContext, useMemo, useState } from 'react';

const MyPedalsChromeContext = createContext(null);

export function MyPedalsChromeProvider({ children }) {
  const [rightSlot, setRightSlot] = useState(null);
  const [addSlot, setAddSlot] = useState(null);
  const value = useMemo(
    () => ({ rightSlot, setRightSlot, addSlot, setAddSlot }),
    [rightSlot, addSlot]
  );
  return (
    <MyPedalsChromeContext.Provider value={value}>
      {children}
    </MyPedalsChromeContext.Provider>
  );
}

export function useMyPedalsChrome() {
  return useContext(MyPedalsChromeContext);
}
